import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const customerWalletOtpApi = createApi({
  reducerPath: 'customerWalletOtpApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({

    startWalletOtp: builder.mutation({
      query: ({ orderId, walletType }) => ({
        url: `/orders/${orderId}/customer_wallet_otp_verifications`,
        method: 'POST',
        body: { wallet_type: walletType },
      }),
    }),

    resendWalletOtp: builder.mutation({
      query: ({ orderId, verificationId }) => ({
        url: `/orders/${orderId}/customer_wallet_otp_verifications/${verificationId}/resend`,
        method: 'POST',
      }),
    }),

    verifyWalletOtp: builder.mutation({
      query: ({ orderId, verificationId, code }) => ({
        url: `/orders/${orderId}/customer_wallet_otp_verifications/${verificationId}/verify`,
        method: 'POST',
        body: { code },
      }),
    }),

  }),
});

export const {
  useStartWalletOtpMutation,
  useResendWalletOtpMutation,
  useVerifyWalletOtpMutation,
} = customerWalletOtpApi;
